import React, { useState } from 'react';
import { MessageCircle, X, ArrowRight, Smile, Send } from 'lucide-react';

const PHONE_NUMBER = "6598563502";
const TELEGRAM_LINK = "https://t.me/+6598563502";
const QUICK_OPTIONS = [
  { label: "Can I see some samples?", text: "Hi! Can I see some samples of your work?" },
  { label: "I'd love to build my website.", text: "Hi! I'd love to build my website with Tiny Systems." },
  { label: "I'd love to learn how to build my own web apps!", text: "Hi! I'm interested in learning how to build my own web apps!" }
];

const WhatsAppWidget: React.FC = () => {
  const [activePlatform, setActivePlatform] = useState<'whatsapp' | 'telegram' | null>(null);

  const handleAction = (text: string) => {
    if (activePlatform === 'whatsapp') {
      const url = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(text)}`;
      window.open(url, '_blank');
    } else {
      // Telegram: Open the provided link directly
      window.open(TELEGRAM_LINK, '_blank');
    }
  };

  return (
    <div className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-[100] flex flex-col items-end gap-3">
      {activePlatform && (
        <div className="mb-4 w-[calc(100vw-48px)] sm:w-[420px] bg-white rounded-[2rem] sm:rounded-[3rem] shadow-2xl border border-gray-100 overflow-hidden animate-in slide-in-from-bottom-4 duration-300">
          <div className="bg-[#7FAF9A] p-6 sm:p-8 text-white">
            <div className="flex justify-between items-start mb-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border-2 border-white/40 overflow-hidden bg-[#E8C547] shadow-inner flex items-center justify-center">
                   <Smile size={28} className="text-[#1F2933] sm:w-[36px] sm:h-[36px]" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="font-black text-xl sm:text-2xl leading-none mb-1.5">Tiny Chat</h3>
                  <div className="flex items-center gap-1.5">
                    <div className="w-2 h-2 rounded-full bg-white animate-pulse"></div>
                    <p className="text-[10px] sm:text-[11px] font-bold opacity-80 uppercase tracking-widest">Typically replies same day</p>
                  </div>
                </div>
              </div>
              <button onClick={() => setActivePlatform(null)} className="opacity-60 hover:opacity-100 transition-opacity p-1 -mt-2">
                <X size={24} />
              </button>
            </div>
            <p className="text-xs sm:text-sm font-bold opacity-90 uppercase tracking-[0.15em]">How can we help today?</p>
          </div>
          
          <div className="p-5 sm:p-8 space-y-3 sm:space-y-4">
            {QUICK_OPTIONS.map((opt, i) => (
              <button
                key={i}
                onClick={() => handleAction(opt.text)}
                className="w-full text-left p-4 sm:p-5 rounded-2xl sm:rounded-3xl bg-gray-50 hover:bg-[#7FAF9A]/5 border border-transparent hover:border-[#7FAF9A]/20 transition-all group flex items-center justify-between"
              >
                <span className="text-sm sm:text-base font-bold text-[#1F2933]/80 group-hover:text-[#7FAF9A] leading-tight">{opt.label}</span>
                <ArrowRight size={16} className="text-[#1F2933]/20 group-hover:text-[#7FAF9A] flex-shrink-0 ml-4 sm:w-[18px]" />
              </button>
            ))}
          </div>
          
          <div className="p-4 sm:p-5 bg-gray-50/50 border-t border-gray-100">
            <p className="text-[10px] sm:text-[11px] text-center text-gray-400 font-bold uppercase tracking-[0.25em]">Speak with us directly</p>
          </div>
        </div>
      )}

      {!activePlatform ? (
        <>
            <button
                onClick={() => setActivePlatform('telegram')}
                className="bg-[#0088cc] text-white w-[44px] h-[44px] sm:w-[72px] sm:h-[72px] rounded-full shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300 flex items-center justify-center relative group"
                aria-label="Chat on Telegram"
            >
                <Send size={20} className="sm:w-[32px] sm:h-[32px] -ml-0.5 sm:-ml-1" />
                <span className="absolute right-full mr-4 bg-white text-[#1F2933] px-3 py-1 rounded-lg text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-lg pointer-events-none hidden sm:block">
                    Telegram
                </span>
            </button>
            <button
                onClick={() => setActivePlatform('whatsapp')}
                className="bg-[#25D366] text-white w-[44px] h-[44px] sm:w-[72px] sm:h-[72px] rounded-full shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300 flex items-center justify-center relative group"
                aria-label="Chat on WhatsApp"
            >
                <MessageCircle size={20} className="sm:w-[32px] sm:h-[32px]" />
                 <span className="absolute right-full mr-4 bg-white text-[#1F2933] px-3 py-1 rounded-lg text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-lg pointer-events-none hidden sm:block">
                    WhatsApp
                </span>
            </button>
        </>
      ) : (
        <button
          onClick={() => setActivePlatform(null)}
          className="bg-[#1F2933] text-white w-[44px] h-[44px] sm:w-[72px] sm:h-[72px] rounded-full shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300 flex items-center justify-center"
        >
          <X size={20} className="sm:w-[32px] sm:h-[32px]" />
        </button>
      )}
    </div>
  );
};

export default WhatsAppWidget;
